import { render, staticRenderFns } from "./VideoCard.vue?vue&type=template&id=63226919&"
import script from "./VideoCard.vue?vue&type=script&lang=js&"
export * from "./VideoCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports